require('./bootstrap');

window.coreui = require('../coreui/vendors/@coreui/coreui/js/coreui.bundle.min.js');
require('../coreui/vendors/simplebar/js/simplebar.min.js');
require('../coreui/vendors/chart.js/js/chart.min.js');
window.coreui.ChartJS = require('../coreui/vendors/@coreui/chartjs/js/coreui-chartjs');
window.coreui.Utils = require('../coreui/vendors/@coreui/utils/js/coreui-utils');

window.Vue = require('vue').default;
window.moment = require('moment');
// window.QRCode = require('qrcode');

require('./gas_slip_request');
require('./driver-trip-ticket-form');
require('./pgo/pending_requests');
require('./pgo/private_requests');
require('./reports');
require('./non_fuel_reports');
require('./office/gas_requests');
require('./office/service_request');
require('./pgo/pgo_service_request');
// require('../coreui/js/main');


import ReportSummary from './components/ReportSummary';

const app = new Vue({
    el: '#admin',
    components: {
        ReportSummary,
    }
});
